import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  align-items: center;\n  display: flex;\n  flex: 0 0 ', 'px;\n  justify-content: center;\n  margin: 0 ', 'px;\n'], ['\n  align-items: center;\n  display: flex;\n  flex: 0 0 ', 'px;\n  justify-content: center;\n  margin: 0 ', 'px;\n']);

import styled from 'styled-components';
import { gridSize, math } from '@atlaskit/theme';

var Expand = styled.div(_templateObject, math.multiply(gridSize, 3), gridSize);

Expand.displayName = 'SingleSelectExpand';

export default Expand;